import React from 'react'
import ItemTypes from '../../lib/item_types'

const I18n = window.I18n

export default class TextareaSettings extends React.Component {

  onChange = (e) => {
    const { item, path, handlers } = this.props
    handlers.updateItemAttr(e, item, ItemTypes.ELEMENT.type, path)
  }

  render () {
    const { label, placeholder, hint } = this.props.item

    return (
      <div className="textarea-settings">
        <div className="form-group">
          <label>{I18n.t('application.titles.label')}</label>
          <input type="text" className="form-control" name="label" value={label || ''} onChange={this.onChange} />
        </div>
        <div className="form-group">
          <label>{I18n.t('application.titles.placeholder')}</label>
          <input type="text"  className="form-control" name="placeholder" value={placeholder || ''} onChange={this.onChange} />
        </div>
        <div className="form-group">
          <label>{I18n.t('application.titles.hint')}</label>
          <textarea className="form-control" name="hint" value={hint || ''} onChange={this.onChange} />
        </div>
      </div>
    )
  }

}
